import React from 'react'
import { Button } from '../ui/button'
import { Users, XCircle, RotateCcw } from 'lucide-react'

export default function OccurrenceTable({ occurrences = [], onUpdate }) {
  const formatDateTime = (dateString) => {
    if (!dateString) return 'N/A'
    const date = new Date(dateString)
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    })
  }

  const getStatusBadge = (status) => {
    switch (status) {
      case 'scheduled':
        return (
          <span className="inline-block px-2 py-1 text-xs rounded bg-green-100 text-green-800 font-medium">
            Scheduled
          </span>
        )
      case 'cancelled':
        return (
          <span className="inline-block px-2 py-1 text-xs rounded bg-red-100 text-red-800 font-medium">
            Cancelled
          </span>
        )
      case 'rescheduled':
        return (
          <span className="inline-block px-2 py-1 text-xs rounded bg-yellow-100 text-yellow-800 font-medium">
            Rescheduled
          </span>
        )
      default:
        return (
          <span className="inline-block px-2 py-1 text-xs rounded bg-gray-100 text-gray-700 font-medium">
            {status}
          </span>
        )
    }
  }

  if (occurrences.length === 0) {
    return (
      <div className="text-center py-8">
        <p className="text-charcoal-muted text-sm">No occurrences found.</p>
      </div>
    )
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead>
          <tr className="border-b border-surface-border">
            <th className="text-left py-3 px-4 text-sm font-semibold text-charcoal-muted">Date / Time</th>
            <th className="text-center py-3 px-4 text-sm font-semibold text-charcoal-muted">Status</th>
            <th className="text-center py-3 px-4 text-sm font-semibold text-charcoal-muted">RSVPs</th>
            <th className="text-right py-3 px-4 text-sm font-semibold text-charcoal-muted">Actions</th>
          </tr>
        </thead>
        <tbody>
          {occurrences.map((occ) => (
            <tr key={occ.id} className="border-b border-surface-border/50 hover:bg-surface-linen/50">
              <td className="py-3 px-4">
                <div className="text-sm text-charcoal">{formatDateTime(occ.startTime)}</div>
                <div className="text-xs text-charcoal-muted">to {formatDateTime(occ.endTime)}</div>
              </td>
              <td className="py-3 px-4 text-center">{getStatusBadge(occ.status)}</td>
              <td className="py-3 px-4 text-center">
                <div className="flex items-center justify-center gap-1 text-charcoal-muted">
                  <Users className="w-4 h-4" />
                  <span className="text-sm">{occ.rsvpCount || 0}</span>
                </div>
              </td>
              <td className="py-3 px-4 text-right">
                <div className="flex items-center justify-end gap-2">
                  {occ.status !== 'cancelled' && (
                    <Button
                      size="sm"
                      variant="outline"
                      className="text-red-600 border-red-200 hover:bg-red-50"
                      onClick={() => onUpdate(occ.id, { status: 'cancelled' })}
                    >
                      <XCircle className="w-3 h-3 mr-1" />
                      Cancel
                    </Button>
                  )}
                  {occ.status === 'cancelled' && (
                    <Button
                      size="sm"
                      variant="outline"
                      className="text-charcoal border-surface-border hover:bg-surface-linen"
                      onClick={() => onUpdate(occ.id, { status: 'scheduled' })}
                    >
                      <RotateCcw className="w-3 h-3 mr-1" />
                      Restore
                    </Button>
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
